<template>
    <!-- 销售单预览 -->
    <div class="print">
        <div v-for="indx of printLength" :key="indx" :class="[indx != printLength?'printPageC':'',printLength > 1&&indx != printLength?'printPage':'','relative']">
            <!-- 头部打印修改处 START -->
            <div class="titleAddress" v-if="category==8">
                <span v-if="(printDetail.fields).indexOf(',contract_no,')!=-1">合同编号: {{printDetail.contract_no}}</span>
                <span v-if="(printDetail.fields).indexOf(',address,')!=-1">签约地: {{printDetail.address}}</span>
            </div>
            <img class="logoprint" src="../../assets/logoPrint.png"/>
            <div class="companyTitle">{{printDetail.title}}</div>
            <div class="order_serial" v-if="(printDetail.fields).indexOf(',order_serial,')!=-1">{{printDetail.order_serial}}</div>
            <div v-if="category==0||category==4" class="tablePerson clearfix">
                <div class="personBox">
                    <div class="person" v-if="(printDetail.fields).indexOf(',customer,')!=-1">客户名称：{{printDetail.customer_name}}</div>
                    <div class="person" v-if="(printDetail.fields).indexOf(',date,')!=-1">销售日期：{{printDetail.sales_time | dateFormat}}</div>
                </div>
                <div class="personBox">
                    <div class="person" v-if="(printDetail.fields).indexOf(',salesman,')!=-1">销售人：{{printDetail.salesman_name}}</div>
                    <div class="person" v-if="(printDetail.fields).indexOf(',order_sn,')!=-1">销售单号：{{printDetail.order_sn}}</div>
                </div>
            </div>
            <div v-if="category==6" class="tablePerson clearfix">
                <div class="personBox">
                    <div class="person" v-if="(printDetail.fields).indexOf(',customer,')!=-1">客户名称：{{printDetail.customer_name}}</div>
                    <div class="person" v-if="(printDetail.fields).indexOf(',date,')!=-1">退货日期：{{printDetail.sales_time | dateFormat}}</div>
                </div>
                <div class="personBox">
                    <div class="person" v-if="(printDetail.fields).indexOf(',salesman,')!=-1">退货人：{{printDetail.salesman_name}}</div>
                    <div class="person" v-if="(printDetail.fields).indexOf(',order_sn,')!=-1">退货单号：{{printDetail.order_sn}}</div>
                </div>
            </div>
            <div v-if="category==1" class="tablePerson clearfix">
                <div class="personBox">
                    <div class="person" v-if="(printDetail.fields).indexOf(',receiver,')!=-1">收货单位：{{printDetail.customer_name}}</div>
                    <div class="person" v-if="(printDetail.fields).indexOf(',address,')!=-1">客户地址：{{printDetail.customer_address}}</div>
                </div>
                <div class="personBox">
                    <div class="person" v-if="(printDetail.fields).indexOf(',order_sn,')!=-1">送货单号：{{printDetail.order_sn}}</div>
                    <div class="person" v-if="(printDetail.fields).indexOf(',date,')!=-1">送货日期：{{printDetail.delivery_time | dateFormat}}</div>
                </div>
            </div>
            <div v-if="category==8" class="tablePerson clearfix">
                <div class="personBox">
                    <div class="person" v-if="(printDetail.fields).indexOf(',owner,')!=-1">甲方(供方): {{printDetail.owner}}</div>
                </div>
                <div class="personBox">
                    <div class="person" v-if="(printDetail.fields).indexOf(',party,')!=-1">乙方(需方): {{printDetail.party}}</div>
                </div>
            </div>
            <!-- 头部打印修改处 END -->
            <div class="tableBox printTableBox">
                <table class="table">
                    <thead>
                        <tr style="font-weight: bold;">
                            <td style="width:50px;">序号</td>
                            <td v-for="(list,index) in printDetail.column" :key="index" v-show="list.show">{{list.name}}</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(list,index) in printDetail.details" :key="index" v-show="index<((indx)*printLimit)&&index>=((indx-1)*printLimit)">
                            <td style="width:50px;">{{index+1}}</td>
                            <td v-for="(item,key,ind) in list" :key="ind" :style="printDetail.column[ind].key=='sales_width'?'width:200px':''">
                                <template v-if="printDetail.column[ind].key=='sales_width'">
                                    <div class="specifications" v-for="(val,number) in printDetail.details[index][printDetail.column[ind].key]" :key="number">
                                        <!-- {{'规格 '+val.spec}}
                                        <br/> -->
                                        {{(val.width).toString()}}
                                    </div>
                                </template>
                                <template v-else>
                                    {{printDetail.details[index][printDetail.column[ind].key]}}
                                </template>
                            </td>
                        </tr>
                        <tr v-if="indx == printLength">
                            <td>合计</td>
                            <td v-for="(item,ind) in printTotal" :key="ind" :colspan="item.col">
                                {{item.content}}
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div class="amountWords" v-if="(printDetail.fields).indexOf(',amount_words,')!=-1">总价金额(大写)： {{printDetail.amount_words}}</div>
            </div>
            <div class="printLianBox clearfix">
                <div class="printLian" v-if="printLength > 1&& indx != printLength && category!=8">{{printDetail.union_pager}}</div>
                <div class="pageNumber" v-if="printLength > 1&& indx != printLength">当前第{{indx}}页/共{{printLength}}页</div>
            </div>

            <!-- 不同打印的分割线 -->
            <div v-if="indx != printLength" class="division"></div>
        </div>

        <!-- 底部打印修改处 START -->
        <div>
            <div class="printTotal clearfix totalItem capitalize" v-if="printDetail.show_receivable==1&&category!=1&&category!=5&&category!=8">
                <div class="printTotalC">合计应收</div>
                <div class="printTotalC" v-if="printDetail.sales_amount&&printDetail.sales_amount!=0.00">销售金额:{{printDetail.sales_amount}}</div>
                <div class="printTotalC" v-if="printDetail.discount_amount&&printDetail.discount_amount!=0.00">折扣金额:{{printDetail.discount_amount}}</div>
                <div class="printTotalC" v-if="printDetail.tax_amount&&printDetail.tax_amount!=0.00">税金<span v-if="printDetail.tax_rate&&printDetail.tax_rate!=0.00">({{printDetail.tax_rate}}%)</span>:{{printDetail.tax_amount}}</div>
                <div class="printTotalC" v-if="printDetail.traffic_amount&&printDetail.traffic_amount!=0.00">关联应收:{{printDetail.traffic_amount}}</div>
                <div class="printTotalC" v-if="printDetail.other_amount&&printDetail.other_amount!=0.00">其它费用:{{printDetail.other_amount}}</div>
                <div class="printTotalC" v-if="printDetail.reduce_amount&&printDetail.reduce_amount!=0.00">优惠:{{printDetail.reduce_amount}}</div>
                <div class="printTotalC">应收金额:{{printDetail.receivable_amount}}</div>
            </div>
            <div class="printTotal clearfix totalItem capitalize" v-if="printDetail.show_receivable==1&&printDetail.receivable_amount_capital">
                <div class="printTotalC">应收金额(大写):<span v-html="`&emsp;`"></span></div>
                <div class="printTotalC">{{printDetail.receivable_amount_capital}}</div>
            </div>
            <div class="printTotal clearfix totalItem capitalize" v-if="category == 5">
                <div class="printTotalC">合计应收</div>
                <div class="printTotalC" v-if="printDetail.sales_amount&&printDetail.sales_amount!=0.00">采购金额:{{printDetail.sales_amount}}</div>
                <div class="printTotalC" v-if="printDetail.tax_amount&&printDetail.tax_amount!=0.00">税金:{{printDetail.tax_amount}}</div>
                <div class="printTotalC">应付金额:{{printDetail.receivable_amount}}</div>
            </div>
            <div class="remarkBox" v-if="(printDetail.fields).indexOf(',remark,')!=-1">
                <div class="remarkTextarea">{{printDetail.remark}}</div>
            </div>
            <div class="truckRemarkBox" v-if="(printDetail.fields).indexOf(',truck_remark,')!=-1">
                <div class="truckRemarkTextarea">{{printDetail.truck_remark}}</div>
            </div>
            <div class="law" v-if="(printDetail.fields).indexOf(',treaty,')!=-1" :style="category==8?'padding-left:0;':''">
                <div class="lawTextFu" v-if="category!=8">附</div>
                <div class="lawText" v-for="(item,index) in printDetail.treaty" :key="index">{{(index+1) +'. '+item}}</div>
            </div>
            <table class="blankMess" v-if="(printDetail.fields).indexOf(',account,')!=-1">
                <tr>
                    <td>收款账户：{{printDetail.account.name}}</td>
                    <td rowspan="4">
                        <div class="codeContent">
                            <div class="codeData" v-if="printDetail.invoice_info">
                                <div class="text">
                                    <span class="name">名称：</span>{{printDetail.invoice_info.invoice_name}}
                                </div>
                                <div class="text">
                                    <span class="name">税号：</span>{{printDetail.invoice_info.invoice_no}}
                                </div>
                                <div class="text">
                                    <span class="name">开户行：</span>{{printDetail.invoice_info.invoice_bank_name}}
                                </div>
                                <div class="text">
                                    <span class="name">账号：</span>{{printDetail.invoice_info.invoice_bank_no}}
                                </div>
                                <div class="text">
                                    <span class="name">地址：</span>{{printDetail.invoice_info.invoice_addr}}
                                </div>
                                <div class="text">
                                    <span class="name">电话：</span>{{printDetail.invoice_info.invoice_phone}}
                                </div>
                            </div>
                            <img class="codeImages" v-if="printDetail.account.pay_url" :src="printDetail.account.pay_url" style="width:70px;height:70px;"/>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td>户名：{{printDetail.account.account_name}}</td>
                </tr>
                <tr>
                    <td>收款账号：{{printDetail.account.bank_no}}</td>
                </tr>
                <tr>
                    <td>开户行：{{printDetail.account.bank_name}}</td>
                </tr>
            </table>
            <div v-if="category==0||category==4||category==6" class="bottomThree clearfix">
                <div class="bottomMessC clearfix">
                    <div class="bottomMess" v-if="(printDetail.fields).indexOf(',info_line,')!=-1">制单人:</div>
                    <div class="bottomMess" v-if="(printDetail.fields).indexOf(',supplier,')!=-1">供方：（盖章）</div>
                    <div class="bottomMess" v-if="(printDetail.fields).indexOf(',supplier,')!=-1">联系人：{{printDetail.salesman_name}}</div>
                    <div class="bottomMess" v-if="(printDetail.fields).indexOf(',supplier,')!=-1">电话：{{printDetail.mobile}}</div>
                </div>
                <div class="bottomMessC clearfix">
                    <div class="bottomMess" v-if="(printDetail.fields).indexOf(',info_line,')!=-1">收货单位签字(盖章)</div>
                </div>
                <div class="bottomMessC clearfix">
                    <div class="bottomMess" v-if="(printDetail.fields).indexOf(',info_line,')!=-1">出货单位签字(盖章)</div>
                    <div class="bottomMess" v-if="(printDetail.fields).indexOf(',demander,')!=-1">需方：（盖章）</div>
                    <div class="bottomMess" v-if="(printDetail.fields).indexOf(',demander,')!=-1">联系人：</div>
                    <div class="bottomMess" v-if="(printDetail.fields).indexOf(',demander,')!=-1">电话：</div>
                </div>
            </div>
            <div v-if="category==1" class="bottomThree clearfix">
                <div class="bottomMessC clearfix">
                    <div class="bottomMess" v-if="(printDetail.fields).indexOf(',info_line,')!=-1">制单人:</div>
                    <div class="bottomMess" v-if="(printDetail.fields).indexOf(',shipper,')!=-1">发货单位：{{companyName}}</div>
                    <div class="bottomMess" v-if="(printDetail.fields).indexOf(',shipper,')!=-1">公司地址：{{printDetail.company_address}}</div>
                    <div class="bottomMess" v-if="(printDetail.fields).indexOf(',shipper,')!=-1">销售人：{{printDetail.salesman_name}}</div>
                    <div class="bottomMess" v-if="(printDetail.fields).indexOf(',shipper,')!=-1">电话：{{printDetail.mobile}}</div>
                </div>
                <div class="bottomMessC clearfix">
                    <div class="bottomMess" v-if="(printDetail.fields).indexOf(',info_line,')!=-1">收货单位签字(盖章)</div>
                    <div class="bottomMess"></div>
                    <div class="bottomMess"></div>
                    <div class="bottomMess" v-if="(printDetail.fields).indexOf(',driver,')!=-1">司机签字：</div>
                </div>
                <div class="bottomMessC clearfix">
                    <div class="bottomMess" v-if="(printDetail.fields).indexOf(',info_line,')!=-1">出货单位签字(盖章)</div>
                    <div class="bottomMess" v-if="(printDetail.fields).indexOf(',receiver_sign,')!=-1">收货单位：</div>
                    <div class="bottomMess" v-if="(printDetail.fields).indexOf(',receiver_sign,')!=-1">收货人签字（盖章）：</div>
                    <div class="bottomMess" v-if="(printDetail.fields).indexOf(',receiver_sign,')!=-1">电话：</div>
                </div>
            </div>
            <div v-if="category==5" class="bottomTwo clearfix">
                <div class="bottomMessC clearfix">
                    <div class="bottomMess" v-if="(printDetail.fields).indexOf(',supplier,')!=-1">供方：（盖章）</div>
                    <div class="bottomMess" v-if="(printDetail.fields).indexOf(',supplier,')!=-1">联系人：{{printDetail.salesman_name}}</div>
                    <div class="bottomMess" v-if="(printDetail.fields).indexOf(',supplier,')!=-1">电话：{{printDetail.mobile}}</div>
                </div>
                <div class="bottomMessC clearfix">
                    <div class="bottomMess" v-if="(printDetail.fields).indexOf(',demander,')!=-1">需方：（盖章）</div>
                    <div class="bottomMess" v-if="(printDetail.fields).indexOf(',demander,')!=-1">联系人：</div>
                    <div class="bottomMess" v-if="(printDetail.fields).indexOf(',demander,')!=-1">电话：</div>
                </div>
            </div>
            <div class="bottom bottomCategory8 clearfix" v-if="(printDetail.fields).indexOf(',one_line,')!=-1&&category==8">
                <div class="bottomMessC clearfix">
                    <div class="bottomMess">甲方：{{printDetail.supplier}}</div>
                </div>
                <div class="bottomMessC clearfix">
                    <div class="bottomMess">乙方：{{printDetail.demander}}</div>
                </div>
            </div>
            <div class="bottom bottomCategory8 clearfix" v-if="category==8">
                <div class="bottomMessC clearfix">
                    <div class="bottomMess" v-if="(printDetail.fields).indexOf(',supplier,')!=-1">甲方：{{printDetail.supplier}}</div>
                    <div class="bottomMess" v-if="(printDetail.fields).indexOf(',supplier,')!=-1">税号：{{printDetail.supplier_tax_no}}</div>
                    <div class="bottomMess" v-if="(printDetail.fields).indexOf(',supplier,')!=-1">开户行：{{printDetail.supplier_bank_name}}</div>
                    <div class="bottomMess" v-if="(printDetail.fields).indexOf(',supplier,')!=-1">账号：{{printDetail.supplier_bank_account}}</div>
                    <div class="bottomMess" v-if="(printDetail.fields).indexOf(',supplier,')!=-1">地址：{{printDetail.supplier_address}}</div>
                    <div class="bottomMess" v-if="(printDetail.fields).indexOf(',supplier,')!=-1">电话：{{printDetail.supplier_phone}}</div>
                    <div class="bottomMess" v-if="(printDetail.fields).indexOf(',supplier,')!=-1">代表签字（盖章）：</div>
                    <div class="bottomMess" v-if="(printDetail.fields).indexOf(',supplier,')!=-1">签订时间：</div>
                </div>
                <div class="bottomMessC clearfix">
                    <div class="bottomMess" v-if="(printDetail.fields).indexOf(',demander,')!=-1">乙方：{{printDetail.demander}}</div>
                    <div class="bottomMess" v-if="(printDetail.fields).indexOf(',demander,')!=-1">税号：{{printDetail.demander_tax_no}}</div>
                    <div class="bottomMess" v-if="(printDetail.fields).indexOf(',demander,')!=-1">开户行：{{printDetail.demander_bank_name}}</div>
                    <div class="bottomMess" v-if="(printDetail.fields).indexOf(',demander,')!=-1">账号：{{printDetail.demander_bank_account}}</div>
                    <div class="bottomMess" v-if="(printDetail.fields).indexOf(',demander,')!=-1">地址：{{printDetail.demander_address}}</div>
                    <div class="bottomMess" v-if="(printDetail.fields).indexOf(',demander,')!=-1">电话：{{printDetail.demander_phone}}</div>
                    <div class="bottomMess" v-if="(printDetail.fields).indexOf(',demander,')!=-1">代表签字（盖章）：</div>
                    <div class="bottomMess" v-if="(printDetail.fields).indexOf(',demander,')!=-1">签订时间：</div>
                </div>
            </div>
        </div>
        <!-- 底部打印修改处 END -->
        <div class="printLianBox clearfix">
            <div class="printLian" v-if="category!=8">{{printDetail.union_pager}}</div>
            <div class="pageNumber">当前第{{printLength}}页/共{{printLength}}页</div>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return{
            companyName:localStorage.dw_erp_company_name,
            printLength:1,
            printLimit:20,
            printDetail:{
                fields:""
            },
            printTotal:[],
            id:"",
            category:"0"
        }
    },
    created(){
        this.id = sessionStorage.getItem('DEMU_ERP_ORDERSEE_ID');
        // this.category = this.$route.query.category;
        this.print()
    },
    methods:{
        print(){
            this.postFuncLoading("/erp/print.confirm",{id:this.id,category:this.category},response=>{
                this.printDetail=response.data.data;
                this.printLimit = parseInt(response.data.data.print_lines);
                this.printDetail.fields = ","+(this.printDetail.fields.join(",").toString())+",";
                this.printLength = Math.ceil(this.printDetail.details.length / this.printLimit);
                this.printDetail.details.forEach((item,index)=>{
                    delete this.printDetail.details[index].status_text;
                })
                response.data.data.statistic.total_cube = this.keepLimit(response.data.data.statistic.total_cube)
                let arr = new Array();
                let objVal = new Object();
                objVal.col = 1;
                objVal.content = "";
                arr.push(objVal);
                let number = 0;
                let arrNum = 0;
                let flag = true;
                this.printDetail.column.forEach((item, index) => {
                    if (item.show) {
                        if (item.key == "sales_cube" || item.key == "sales_amount" || item.key == "number") {
                            flag = false;
                            let obj = new Object();
                            obj.col = 1;
                            if (item.key == "sales_cube") {
                                obj.content = response.data.data.statistic.total_cube;
                            } else if (item.key == "sales_amount") {
                                obj.content = response.data.data.statistic.total_amount;
                            }else if (item.key == "number") {
                                obj.content = response.data.data.statistic.total_number;
                            }
                            arr.push(obj)
                            arr[arrNum].col = number;
                            arrNum++;
                            number = 0;
                            if (this.printDetail.column.length - 1 > index) {
                                let objC = new Object();
                                objC.col = 1;
                                objC.content = "";
                                arr.push(objC)
                                arrNum++;
                            }
                        } else {
                            number++;
                        }
                    }
                    if (this.printDetail.column.length - 1 == index) {
                        if (item.key != "sales_cube" || item.key != "sales_amount") {
                            arr[arr.length - 1].col = number;
                        }
                    }
                });
                if(flag){
                    arr[0].col = number;
                }
                arr.forEach((each,index)=>{
                    if(each.col == 0 && each.content == ''){
                        arr.splice(index,1);
                    }
                })
                this.printTotal = arr;
                this.printDetail.treaty.forEach(item => {
                    item = item.replace(/\n/g, '<br />');
                });
                // setTimeout(() => {
                //     this.printFunc();
                // }, 0);
            },error=>{
                this.tip(error.data.message,"warning")
            })
        },
        printFunc(){
            if(!!window.netscape){
                window.print()
                setTimeout(()=>{window.close()}, 0);
            }else{
                var tata=document.execCommand("print");
                if(tata){
                    window.close()
                }
            }
        },
    }
}
</script>
<style scoped lang="scss">
    .print{position: relative;width: 800px;margin: 20px auto;padding: 20px; min-height: 100vh;box-sizing: border-box;display: block !important;background: #fff;}
    .print .pageNumber{font-size: 12px;text-align: center;height: 20px;line-height: 20px;float: right;}
    .print .printTable{position: relative;display: block;}
    .division{margin: 20px -20px 0 -20px;height: 20px;background: #EEEFF2;}
    .printPage{padding-bottom:25px;position: relative;box-sizing: border-box;}
    .relative{position: relative;}
    .logoprint{width:130px;position: absolute;top:0;left:0;}
    .law{padding-top:10px;padding-left:20px;position: relative;padding-bottom:5px;}
    .lawTextFu{position: absolute;top:10px;left:0;font-size:12px;}
    .lawText{font-size: 12px;margin-bottom:5px; text-align: left;}
    .blankMess td{font-size: 12px;border:1px solid #777;width:50%;padding:3px 10px;text-align: left;}
    .blankMess{border-collapse:collapse;width:100%;margin-top:10px; }
    .codeContent{display: flex;align-items: center;justify-content: space-between;}
    // .print{position: relative;}
    .print .specifications{text-align: left;font-size: 12px;padding:0 10px;box-sizing: border-box;}
    .print .title{font-size: 16px;font-weight: 600;padding-bottom:20px;}
    .print .companyTitle{font-size: 20px;font-weight: 600;padding-bottom:15px;text-align: center;height:40px;}
    // .print .tablePerson{}
    .print .personBox{float: left;}
    .print .personBox:nth-child(2n){float: right;}
    .print .personBox .person{text-align: left;}
    .print .personBox:nth-child(2n) .person{text-align: right;}
    .print .person{font-size: 14px;}
    .print .table td{font-size: 14px;padding:2px 0;border: 1px solid #777;box-sizing:content-box;}
    .print .table tr td:last-child{box-sizing: border-box;}
    .print .table{width:100%;border-collapse:collapse;}
    .print .remarkBox{width:100%;border:1px solid #777;border-top:0;box-sizing: border-box;padding:0 5px 0 40px;position: relative;}
    .print .remarkBox:before{content:"\5907\6CE8:";position: absolute;font-size: 12px;color: #777;top:2px;left:5px; }
    .print .remarkBox .remarkTextarea{width:100%;border:0;color:#777;min-height:25px;text-align: left;font-size: 12px;padding:3px 0;line-height: 15px;}
    .print .truckRemarkBox{width:100%;border:1px solid #777;border-top:0;box-sizing: border-box;padding:0 5px 0 60px;position: relative;}
    .print .truckRemarkBox:before{content:"\8F66\724C\5907\6CE8:";position: absolute;font-size: 12px;color: #777;top:2px;left:5px;font-weight: 600;}
    .print .truckRemarkBox .truckRemarkTextarea{width:100%;border:0;color:#777;min-height:25px;text-align: left;font-size: 12px;padding:3px 0;line-height: 15px;}
    .print .bottomMess:first-child{margin-top:5px;}
    .print .bottomMess{font-size: 12px;padding:2px 0;width:100%;}
    .print .bottomMessC{width:35%;float: left;text-align: left;}
    .print .bottomMessC:nth-child(3n){float: right;width:120px;margin-right:20%}
    .print .printTotal{width: 100%;border: 1px solid #777;border-top:0;text-align: right;}
    .print .totalItem{display: flex;flex-wrap: wrap;}
    .print .capitalize{display: block;}
    .print .printTotalC{font-size: 14px;font-weight: 600;margin-left: 10px;margin-right: 10px;line-height: 25px;display: inline;}
    .print .printTotalC:first-child{float: left;}
    .capitalizeC{font-size: 14px;font-weight: 600;margin-left: 10px;margin-right: 10px;line-height: 25px;display: inline; float: right;}
    td{text-align: center;}

    .print .bottomTwo .bottomMessC{width:35%!important;float: left;}
    .print .bottomTwo .bottomMessC:nth-child(2n){float: right;width:120px!important;margin-right:0;}

    .print .bottomThree .bottomMessC{width:30%!important;float: left;}
    .print .bottomThree .bottomMessC:nth-child(2n){float: left;width:20%!important;margin-right:0;}
    .print .bottomThree .bottomMessC:nth-child(3n){float: right;width:30%!important;margin-right:10%;}
    .print .bottom{position: relative;}
    .info_line{position: absolute;top:0;width:300px;text-align: center;font-size: 12px;padding:7px 0;left:20%;}
    .order_serial{font-size: 12px;position: absolute;top:10px;right:0;}
    .amountWords{font-size: 12px;border:1px solid #000;border-top:0;padding:5px 5px;text-align: left;}
    .bottomCategory8 .bottomMess{width:280px;}
    .bottomCategory8 .bottomMessC:nth-child(2n){width:280px;float: right;}
    .info_lineC .one_line{float: left;font-size: 12px;}
    .info_lineC .one_line:nth-child(2n){width:200px;float: right;}
    .titleAddress{border-bottom:1px solid #000;padding:5px 0;text-align: right;margin-bottom:10px;}
    .titleAddress span{font-size: 12px;margin-left:20px;}
</style>
